import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import MasterService from "./MasterService.js";
import Header from "../Component/Header.js";
import Menu from "../Component/Menu.js";
import Footer from "../Component/Footer.js";
import { Backdrop, Checkbox, CircularProgress, FormControlLabel, FormGroup, FormLabel, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import { prefix1 } from "../Common/Credentials.js";
import moment from "moment";
import UploadFilesService from "../Common/upload/UploadFilesService.js";
import FileServices from "../Common/upload/FileServices.js";

class Viewtenants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.location.state.data,
      adminuser: this.props.location.state.data.adminuser,
      clisettings: this.props.location.state.data.clisettings,
      productsstats: this.props.location.state.data.productsstats,
      loading: false,
      showproducts: false,
      accounts: false,
      appmaster: false,
      inventory: false,
      purchase: false,
      sales: false,
      production: false,
      assetmanagement: false,
      salestravel:false,
      dashboard: true,
      loader: false,
      prodloader:false,
      selectedFiles: undefined,
      currentFile: undefined,
      previewImage: undefined,
      progress: 0,
      message: "",
      isError: false,
      fileInfos: [],
      fileInfo: "",
    };
    this.deleteTenant = this.deleteTenant.bind(this);
  }

  handleProductChange = (e) => {
    this.setState({ ...this.state, [e.target.name]: e.target.checked });
  };

  deleteTenant(id) {
    MasterService.deleteTenant(id)
      .then((resposne) => this.props.navigate(`/`))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  }

  handleAddUser = () => {
    Swal.fire({
      title: "Add Default User of Tenant?",
      text: "Are you sure?",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.setState({loader:true})
    MasterService.addAdminUser(this.state.data.id)
      .then(() =>{
       this.setState({ adminuser: 1,loader:false })
       Swal.fire({
        title: "Default user added successfully",
        text: ".",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#152f5f",
      });
      })
      .catch((e) => {
        this.setState({loader:false})
        Swal.fire({
          title: "Error occurred, please try again",
          text: ".",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#152f5f",
        });
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
    }
  }
  )
  };
  handleAddSettings = () => {
    Swal.fire({
      title: "Add Default Settings of Tenant?",
      text: "Are you sure?",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.setState({loader:true})
        MasterService.addclientssettings(this.state.data.id)
          .then(() => {
            this.setState({ clisettings: 1, loader: false });
            Swal.fire({
              title: "Default settings added successfully",
              text: ".",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          })
          .catch((e) => {
            this.setState({loader:false})
            Swal.fire({
              title: "Error occurred, please try again",
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
            this.setState({ loader: false });
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
          });
      }
    });
    // MasterService.addclientssettings(this.state.data.id)
    // .then(() => this.setState({clisettings:1}))
    // .catch((e) => {
    //   if (e.response.data.error === "Unauthorized") {
    //     alert("Your Session is Lost: Please login Back to resume");
    //     this.props.navigate(`/`);
    //   }
    // });
  };

  adddefaultprefixes = () => {
    Swal.fire({
      title: "Add Default Prefixes of Tenant?",
      text: "Are you sure?",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.setState({loader:true})
        MasterService.adddefaultprefixes(this.state.data.id)
          .then(() => {
            this.setState({ prefixstatus: 1, loader: false });
            Swal.fire({
              title: "Prefixes added successfully",
              text: ".",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          })
          .catch((e) => {
            this.setState({ loader: false });
            Swal.fire({
              title: "Error occurred, please try again",
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
          });
      }
    });
  };

  componentDidMount(){
   MasterService.getClientEnabledProducts(this.props.location.state.data.id)
   .then((response) =>
   response.data.map(e=>{

    if(e.products ==="accounts"){this.setState({ accounts:e.productsEnabled === "YES"?true:false})}
    if(e.products ==="appmaster"){this.setState({ appmaster:e.productsEnabled === "YES"?true:false})}
    if(e.products ==="inventory")this.setState({ inventory:e.productsEnabled === "YES"?true:false})
    if(e.products ==="purchase")this.setState({ purchase:e.productsEnabled === "YES"?true:false})
    if(e.products ==="sales")this.setState({ sales:e.productsEnabled === "YES"?true:false})
    if(e.products ==="production")this.setState({ production:e.productsEnabled === "YES"?true:false})
    if(e.products ==="assetmanagement")this.setState({ assetmanagement:e.productsEnabled === "YES"?true:false})
    if(e.products ==="salestravel")this.setState({ salestravel:e.productsEnabled === "YES"?true:false})
    // if(e.products.products ==="accounts"){this.setState({ accounts:e.productenabled === "YES"?true:false})}
    // if(e.products.products ==="appmaster"){this.setState({ appmaster:e.productenabled === "YES"?true:false})}
    // if(e.products.products ==="inventory")this.setState({ inventory:e.productenabled === "YES"?true:false})
    // if(e.products.products ==="purchase")this.setState({ purchase:e.productenabled === "YES"?true:false})
    // if(e.products.products ==="sales")this.setState({ sales:e.productenabled === "YES"?true:false})
    // if(e.products.products ==="production")this.setState({ production:e.productenabled === "YES"?true:false})
    // if(e.products.products ==="assetmanagement")this.setState({ assetmanagement:e.productenabled === "YES"?true:false})
    // if(e.products.products ==="salestravel")this.setState({ salestravel:e.productenabled === "YES"?true:false})
  }))
  }

  handleAddproductsstats = () => {
    this.setState({prodloader:true})
    let data = {
      accounts: this.state.accounts,
      appmaster: this.state.appmaster,
      inventory: this.state.inventory,
      purchase: this.state.purchase,
      sales: this.state.sales,
      production: this.state.production,
      assetmanagement: this.state.assetmanagement,
      dashboard:this.state.dashboard,
      salestravel:this.state.salestravel,
      id: this.state.data.id,
    };
    this.state.data.productsstats === 0
      ? Swal.fire({
          title: "Add products to Tenant?",
          text: "Are you sure?",
          icon: "question",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: "Yes",
          confirmButtonColor: "#152f5f",
          cancelButtonText: "No",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            this.setState({ loader: true });
            MasterService.addnewTenantProducts(data)
              .then(() => {
                this.setState({
                  productsstats: 1,
                  showproducts: false,
                  loader: false,
                  prodloader: false,
                });
                Swal.fire({
                  title: "Products added successfully",
                  text: ".",
                  icon: "success",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#152f5f",
                });
              })
              .catch((e) => {
                this.setState({ loader: false,prodloader: false, });
                Swal.fire({
                  title: "Error occurred, please try again",
                  text: ".",
                  icon: "error",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#152f5f",
                });
                if (e.response.data.error === "Unauthorized") {
                  alert("Your Session is Lost: Please login Back to resume");
                  this.props.navigate(`/`);
                }
              });
          }
        })
      : Swal.fire({
          title: "Update products to Tenant?",
          text: "Are you sure?",
          icon: "question",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: "Yes",
          confirmButtonColor: "#152f5f",
          cancelButtonText: "No",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            this.setState({ loader: true})
            MasterService.updateTenantProducts(data)
              .then(() => {
                this.setState({
                  productsstats: 1,
                  showproducts: false,
                  loader: false,
                  prodloader: false,
                });
                Swal.fire({
                  title: "Products Updated successfully",
                  text: ".",
                  icon: "success",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#152f5f",
                });
              })
              .catch((e) => {
                this.setState({ loader: false,prodloader: false, });
                Swal.fire({
                  title: "Error occurred, please try again",
                  text: ".",
                  icon: "error",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#152f5f",
                });
                if (e.response.data.error === "Unauthorized") {
                  alert("Your Session is Lost: Please login Back to resume");
                  this.props.navigate(`/`);
                }
              });
          }
        });
    // MasterService.updateTenantProducts(data).then(() => this.setState({productsstats:1,showproducts:false}))
    // .catch((e) => {
    //   if (e.response.data.error === "Unauthorized") {
    //     alert("Your Session is Lost: Please login Back to resume");
    //     this.props.navigate(`/`);
    //   }
    // })
  };

  selectFile = (event) => {
    var fi = event.target;
    console.log(fi.files);
    if (fi.files.length > 0) {
      // FIRST CHECK IF ANY FILE IS SELECTED.

      for (var i = 0; i <= fi.files.length - 1; i++) {
        var fileName, fileExtension

        // FILE NAME AND EXTENSION.
        fileName = fi.files.item(i).name;
        fileExtension = fileName.replace(/^.*\./, "");
        if (
          fileExtension === "png" ||
          fileExtension === "jpg" ||
          fileExtension === "jpeg" ||
          fileExtension === "jfif"
        ) {
          // readImageFile(fi.files.item(i)); // GET IMAGE INFO USING fileReader().
          this.setState({
            selectedFiles: event.target.files,
            previewImage: URL.createObjectURL(event.target.files[0]),
          },() => {this.state.selectedFiles});
          document.getElementById("fileInfo").innerHTML = ""
        } else {
          document.getElementById("fileInfo").innerHTML =
            "Unsupported format. Please Upload 'png' or 'jpg' or 'jpeg' type image";
        }
      }

      // GET THE IMAGE WIDTH AND HEIGHT USING fileReader() API.
      //   function readImageFile(file) {
      //     var reader = new FileReader(); // CREATE AN NEW INSTANCE.

      //     reader.onload = function (e) {
      //       var img = new Image();
      //       var w, h;
      //       img.src = e.target.result;

      //       img.onload = function () {
      //         w = this.width;
      //         h = this.height;
      //         setsize(w, h);
      //         // if(w<=150 && h<=150){document.getElementById('fileInfo').innerHTML = ''}
      //         // else{document.getElementById('fileInfo').innerHTML = "File size should be lessthan or equal to 150x150"}
      //       };
      //     };
      //     // const setsize = (w, h) => {
      //     //   width = w;
      //     //   height = h;
      //     //   // this.setState("hi")
      //     // };
      //     reader.readAsDataURL(file);
      //   }
    }
  };

   upload = () => {
      // if(width<=150 && height<=150){
      let currentFile = this.state.selectedFiles[0];

      let year = new Date().getFullYear();
      let day = new Date().getDate();
      let mn = new Date().getMonth() + 1;
      let curmonth = moment(mn, "M").format("MMMM");
  
      this.setState({ progress: 100, currentFile: currentFile });
  
      UploadFilesService.logoupload(
        currentFile,
        year,
        curmonth,
        "logo",
        prefix1,
        day,
        (event) => {
          this.setState({
            progress: Math.round((100 * event.loaded) / event.total),
            file: currentFile
          });
        }
      )
        .then((response) => {
          this.setState({
            message: response.data.message,
            isError: false,
          });
          return FileServices.getFiles1(currentFile.name);
        })
        .then((files) => {
          let year = new Date().getFullYear();
          let day = new Date().getDate();
          let mn = new Date().getMonth() + 1;
          let curmonth = moment(mn, "M").format("MMMM");
          let filedata = files.data.map((e) => e.name);
          let path = prefix1 +"/" +"logo" +"/" +prefix1 +"/" +year +"/" +curmonth +"/" +day;
          MasterService.updateTenantLogo({ id: this.state.data.id, logofile: filedata.toLocaleString(), logopath: path, })
          this.setState({ fileInfos: files.data, file: files.data.map((e) => e.name).toLocaleString() });
        })
  
        .catch((err) => {
          console.log(err)
          this.setState({
            progress: 0,
            message: "Could not upload the file!",
            currentFile: undefined,
            isError: true,
          });
        });
      this.setState({ selectedFiles: undefined });
      // }else{
      //   this.setState({selectedFiles: undefined,previewImage:undefined});
      // }
    }

  render() {
    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="card">
            <ol className="breadcrumb float-sm-right">
              <Link as="button" className=" text-secondary" to="/tenants">
                ❮ Back &nbsp;&nbsp;
              </Link>
              <li className="breadcrumb-item text-secondary">
                <Link to="/superadminmasters">Home</Link>
              </li>
              <li className="breadcrumb-item text-secondary">
                <Link to="/tenants">Tenants</Link>
              </li>
              <li className="breadcrumb-item active">Tenants Detais</li>
            </ol>
            <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.loader}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

            <section className="content">
              <div className="container-fluid">
                
                    <div className="card">
                      <div className="card-body">
                      <div className="form-row">
                                <div className="form-column col-md-12">
                                  <table className="float-left mb-3">
                            <tbody>
                              <tr>
                                <td>Company</td>
                                <td>: {this.state.data.companyname}</td>
                              </tr>
                              <tr>
                                <td>Contact Name</td>
                                <td>: {this.state.data.contactname}</td>
                              </tr>
                              <tr>
                                <td>Prefix/Subdomain</td>
                                <td>: {this.state.data.prefix}</td>
                              </tr>
                              <tr>
                                <td>Contact Number&nbsp;&nbsp;</td>
                                <td>
                                  : +{this.state.data.phonecode}-
                                  {this.state.data.contactnumber}
                                </td>
                              </tr>
                              {this.state.data.alternatenumber ===''|| this.state.data.alternatenumber === null ? '' :
                              <tr>
                                <td>Alternate Number&nbsp;&nbsp;</td>
                                <td>
                                  : +{this.state.data.phonecode}-
                                  {this.state.data.contactnumber}
                                </td>
                              </tr>
                                }
                              <tr>
                                <td>Email</td>
                                <td>: {this.state.data.email}</td>
                              </tr>
                              <tr>
                                <td>Address</td>
                                <td>
                                  : {this.state.data.address}{" "}
                                  {this.state.data?.address2}
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  &nbsp;&nbsp;{this.state.data?.city?.name},
                                  {this.state.data?.state?.name}
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  &nbsp;&nbsp;
                                  {this.state.data?.country?.name} -{" "}
                                  {this.state.data.zip}
                                </td>
                              </tr>
                              <tr>
                                <td>Zone</td>
                                <td>: {this.state.data.zoneid}</td>
                              </tr>
                              {this.state.data.country.name==="India"?<>
                              <tr>
                                <td>PAN</td>
                                <td>: {this.state.data.pan}</td>
                              </tr>
                              <tr>
                                <td>GSTIN</td>
                                <td>: {this.state.data.gstin}</td>
                              </tr>
                              <tr>
                                <td>E-invoice</td>
                                <td>: {this.state.data.einvoice}</td>
                              </tr>
                              </>:""}
                              <tr>
                                <td>Currency</td>
                                <td>: {this.state.data?.currency?.currency}</td>
                              </tr>
                              <tr>
                                <td>Financial Start Date</td>
                                <td>: {this.state.data.fystartdate}</td>
                              </tr>
                              <tr>
                                <td>Financial End Date</td>
                                <td>: {this.state.data.fyenddate}</td>
                              </tr>
                              <tr>
                                <td>Transaction From</td>
                                <td>: {this.state.data.transactionFrom}</td>
                              </tr>
                              <tr>
                                <td>Client Type</td>
                                <td>: {this.state.data.clientType}</td>
                              </tr>
                              <tr>
                                <td>Enguagment Type</td>
                                <td>: {this.state.data.enguagment}</td>
                              </tr>
                              <tr>
                                <td>Initialsetup</td>
                                <td>: {this.state.data.initialsetup}</td>
                              </tr>
                              <tr>
                                <td>Number Of Users</td>
                                <td>: {this.state.data.noofusers}</td>
                              </tr>
                              <tr>
                                <td>Plan Type</td>
                                <td>: {this.state.data.plantype}</td>
                              </tr>
                            </tbody>
                          </table>
                          </div>

                          <div className="col-md-12">
                                                <label className="UI-label mt-3">Logo Upload :&nbsp;&nbsp; {this.state.selectedFiles && this.state.selectedFiles.length > 0? this.state.selectedFiles[0].name: ""}</label>
                                                {/* {this.state.file !== ''? 
                                                <Link as="button"  onClick={this.handlePurchaseorder}>{this.state.file}</Link>
                                                : */}
                                                {/* <> */}
                                                {!this.state.selectedFiles ? (<>
                                                   <div
                                                   onClick={() => document.getElementById("fileInput").click()}
                                                   className="tw-border-2 tw-border-dashed tw-border-gray-300 tw-p-6 tw-text-center tw-rounded-lg hover:tw-bg-gray-50 tw-cursor-pointer"
                                                 >
                                                   <p className="tw-text-gray-500">Click to upload</p>
                                         
                                                   <input
                                                     id="fileInput"
                                                     type="file"
                                                     accept="image/*"
                                                     onChange={this.selectFile}
                                                     className="tw-hidden"
                                                   />
                                                 </div>
                                                  {/* <label htmlFor="btn-upload"> */}
                                                    {/* <input
                                                      className="btn-choose text-sm"
                                                      id="btn-upload"
                                                      name="btn-upload"
                                                      style={{ display: "none" }}
                                                      type="file"
                                                      onChange={this.selectFile}
                                                    /> */}
                                                  {/* </label> */}
                                                  </>
                                                ) : (
                                                  <>
                                                    <button
                                                     type="button"
                                                      className="UI-btn UI-btn-primary mx-1"
                                                      variant="contained"
                                                      component="span"
                                                      disabled={!this.state.selectedFiles}
                                                      onClick={() => this.upload()}
                                                    >
                                                      upload
                                                    </button>
                                                    <span
                                                      as="button"
                                                      className="UI-btn UI-btn-outline"
                                                      onClick={() =>
                                                        this.setState({
                                                          selectedFiles: undefined,
                                                          previewImage: undefined,
                                                        })
                                                      }
                                                    >
                                                      Reupload
                                                    </span>
                                                  </>
                                                )}
                                                <p id="fileInfo" className="text-red ml-4"></p>
                                                <div className=" col-md-3" />
                                                {this.state.previewImage && (
                                                  <div>
                                                    {this.state.imageloader === true ? (
                                                      <Spinner />
                                                    ) : (
                                                      <img
                                                        alt="Logo..."
                                                        // width="100%"
                                                        height="150"
                                                        className="finanzzlogo"
                                                        src={this.state.previewImage}
                                                      />
                                                    )}
                                                  </div>
                                                )}
                                                {/* </fieldset> */}
                                                <div className=" col-md-9">
                                                  <Typography
                                                    variant="subtitle2"
                                                    className={`upload-message ${
                                                      this.state.isError ? "error" : ""
                                                      }`}
                                                  >
                                                    <span className="text-green">{this.state.message}</span>
                                                  </Typography>
                                                </div>
                                                {/* </>} */}
                                              </div>

                            {this.state.showproducts === true ? (
                              <div>
                                <FormLabel>
                                  Select Products
                                </FormLabel>
                                <FormGroup row>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.appmaster}
                                        onChange={this.handleProductChange}
                                        name="appmaster"
                                        color="primary"
                                      />
                                    }
                                    label="AppMaster"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.accounts}
                                        onChange={this.handleProductChange}
                                        name="accounts"
                                        color="primary"
                                      />
                                    }
                                    label="Accounts"
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.inventory}
                                        onChange={this.handleProductChange}
                                        name="inventory"
                                        color="primary"
                                      />
                                    }
                                    label="Inventory"
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.sales}
                                        onChange={this.handleProductChange}
                                        name="sales"
                                        color="primary"
                                      />
                                    }
                                    label="Sales"
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.purchase}
                                        onChange={this.handleProductChange}
                                        name="purchase"
                                        color="primary"
                                      />
                                    }
                                    label="Purchase"
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.production}
                                        onChange={this.handleProductChange}
                                        name="production"
                                        color="primary"
                                      />
                                    }
                                    label="Production"
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.assetmanagement}
                                        onChange={this.handleProductChange}
                                        name="assetmanagement"
                                        color="primary"
                                      />
                                    }
                                    label="Asset Management"
                                  />

                                <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.salestravel}
                                        onChange={this.handleProductChange}
                                        name="salestravel"
                                        color="primary"
                                      />
                                    }
                                    label="Sales Travel"
                                  />


                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.state.dashboard}
                                        onChange={this.handleProductChange}
                                        name="dashboard"
                                        color="primary"
                                        disabled
                                      />
                                    }
                                    label="Dashboard"
                                  />

                                </FormGroup>
                                
                                <div>
                                <span
                                  as="button"
                                  className="btn btn-sm hovbuttonColour mr-2"
                                  onClick={this.handleAddproductsstats}
                                >
                                  Save
                                </span>
                                <span
                                  as="button"
                                  className="btn btn-sm deletebutton"
                                  onClick={() =>
                                    this.setState({ showproducts: false })
                                  }
                                >
                                  Cancel
                                </span>
                                </div>
                              </div>
                            ) : (
                              <>
                                <Link
                                  as="button"
                                  className="btn btn-sm hovbuttonColour mr-2"
                                  to={{pathname: "/newtenant"}}
                                    state= {{
                                      id: this.state.data.id,
                                      name: "Update Tenant"
                                  }}
                                >
                                  Edit
                                </Link>
                                <button
                                  as="button"
                                  className="btn btn-sm deletebutton mr-2"
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        `Are you sure you wish to delete Tenant ${this.state.data.id}?`
                                      )
                                    )
                                      this.deleteTenant(this.state.data.id);
                                  }}
                                >
                                  Delete
                                </button>
                                {this.state.productsstats === 0 ? (
                                  <button
                                    as="button"
                                    className="btn btn-sm hovbuttonColour mr-2"
                                    onClick={() =>
                                      this.setState({ showproducts: true })
                                    }
                                    disabled={this.state.prodloader}
                                  >
                                    Add Products
                                  </button>
                                ) : (
                                  <button
                                    as="button"
                                    className="btn btn-sm hovbuttonColour mr-2"
                                    onClick={() =>
                                      this.setState({ showproducts: true })
                                    }
                                    disabled={this.state.prodloader}
                                  >
                                    Update Products
                                  </button>
                                )}
                                {this.state.adminuser === 0 ? (
                                  <button
                                    as="button"
                                    className="btn btn-sm hovbuttonColour mr-2"
                                    onClick={
                                      this.state.productsstats === 0
                                        ? ""
                                        : this.handleAddUser
                                    }
                                    disabled={this.state.productsstats === 0}
                                  >
                                    Add User
                                  </button>
                                ) : (
                                  ""
                                )}

                                {this.state.clisettings === 0 ? (
                                  <button
                                    as="button"
                                    className="btn btn-sm hovbuttonColour mr-2"
                                    onClick={
                                      this.state.adminuser === 0
                                        ? ""
                                        : this.handleAddSettings
                                    }
                                    disabled={this.state.adminuser === 0}
                                  >
                                    Add Settings
                                  </button>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                            </div>
                   </div>
                    </div>
                  </div>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(Viewtenants);
